
// import '@/img/_ogp.jpg'
import '@/css/style-front';
import template from './template/front-tmpl';
import pageHome from './pages/front/home';
import pageArticleIndex from './pages/front/article-index';
import pageArticleShow from './pages/front/article-show';
import pageFeatureIndex from './pages/front/feature-index';
import pageFeatureShow from './pages/front/feature-show';
import pageNewsIndex from './pages/front/news-index';
import pageNewsShow from './pages/front/news-show';
import pageVoiceComplete from './pages/front/voice-complete';
import pageVoiceIndex from './pages/front/voice-index';
import pageVoiceCreate from './pages/front/voice-create';

window.addEventListener('load', () => {
    template();
    pageHome();
    pageArticleIndex();
    pageArticleShow();
    pageFeatureIndex();
    pageFeatureShow();
    pageNewsIndex();
    pageNewsShow();
    pageVoiceComplete();
    pageVoiceIndex();
    pageVoiceCreate();
 })
